import type { QueryClient } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { OrganizationsService, type UserPublic } from "@/client"
import SchoolAnalytics from "@/components/Organizations/SchoolAnalytics"

export const Route = createFileRoute(
  "/_layout/organizations/$organizationId/analytics/schools",
)({
  component: OrganizationSchoolAnalyticsPage,
  beforeLoad: async ({ context, params }) => {
    const queryClient = (context as { queryClient: QueryClient }).queryClient
    const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"])

    if (currentUser?.is_superuser) {
      return
    }

    try {
      await queryClient.fetchQuery({
        queryKey: ["organization", params.organizationId],
        queryFn: () =>
          OrganizationsService.getOrganization({
            orgId: params.organizationId,
          }),
      })
    } catch (_error) {
      throw redirect({ to: "/organizations" })
    }
  },
})

function OrganizationSchoolAnalyticsPage() {
  const { organizationId } = Route.useParams()

  return <SchoolAnalytics orgId={organizationId} />
}
